var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07645 42.229L25.2679 9.08025C26.3285 7.2482 26.8588 6.33217 27.5507 6.02452C28.1543 5.75615 28.8433 5.75615 29.4468 6.02452C30.1387 6.33217 30.669 7.2482 31.7297 9.08024L50.9211 42.229C51.9856 44.0677 52.5178 44.987 52.4392 45.7415C52.3705 46.3996 52.0257 46.9977 51.4906 47.3868C50.877 47.8329 49.8147 47.8329 47.6902 47.8329H9.30738C7.18282 47.8329 6.12054 47.8329 5.50698 47.3868C4.97181 46.9977 4.62701 46.3996 4.5584 45.7415C4.47974 44.987 5.01197 44.0677 6.07645 42.229Z",
    fill: "#FFFBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4988 20.9996V30.3329M28.4988 39.6662H28.5221M25.2679 9.08025L6.07645 42.229C5.01197 44.0677 4.47974 44.987 4.5584 45.7415C4.62701 46.3996 4.97181 46.9977 5.50698 47.3868C6.12054 47.8329 7.18282 47.8329 9.30738 47.8329H47.6902C49.8147 47.8329 50.877 47.8329 51.4906 47.3868C52.0257 46.9977 52.3705 46.3996 52.4392 45.7415C52.5178 44.987 51.9856 44.0677 50.9211 42.229L31.7297 9.08024C30.669 7.2482 30.1387 6.33217 29.4468 6.02452C28.8433 5.75615 28.1543 5.75615 27.5507 6.02452C26.8588 6.33217 26.3285 7.2482 25.2679 9.08025Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.da1f4b25b8b345eb5705f09b3b8a44f5.svg";
export { ForwardRef as ReactComponent };